import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type { ITeam } from 'modules/teams/store/models/Team'

import TeamList from './List'

interface Props {
  team: ITeam
  readonly?: boolean
  contractVersions: ContractVersions
}

const Members = ({ team, readonly, contractVersions }: Props) => {
  return (
    <Box>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('employees.common.team_members')}
        </Text.Normal>
      </Box>
      <TeamList team={team} readonly={readonly} contractVersions={contractVersions} />
    </Box>
  )
}

export default observer(Members)
